import { useEffect, useState } from "react";
import { Logo } from "../Logo";
import { AuthButton } from "../AuthButton";
import { fetchAuthConfig, login } from "../../lib/auth";
import { Hero } from "./Hero";
import { Pillars } from "./Pillars";
import { HowItWorks } from "./HowItWorks";
import { Pricing } from "./Pricing";
import { FAQ } from "./FAQ";
import { CTASection } from "./CTASection";
import { Footer } from "./Footer";

export function Landing(): JSX.Element {
  const [authEnabled, setAuthEnabled] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    void fetchAuthConfig().then((c) => setAuthEnabled(c.enabled));
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleCta = async () => {
    if (authEnabled) {
      try {
        await login();
      } catch {
        /* noop */
      }
    } else {
      window.location.href = "/?signup=1";
    }
  };

  return (
    <div className="min-h-screen bg-ink-900 text-white overflow-x-hidden">
      <header
        className={
          "fixed top-0 inset-x-0 z-50 transition-all " +
          (scrolled
            ? "bg-ink-900/80 backdrop-blur-md border-b border-ink-700"
            : "bg-transparent border-b border-transparent")
        }
      >
        <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
          <a href="/" className="flex items-center">
            <Logo size="md" />
          </a>
          <nav className="hidden md:flex items-center gap-7 text-sm text-ink-200">
            <a href="#how" className="hover:text-white transition">Jak to działa</a>
            <a href="#pricing" className="hover:text-white transition">Cennik</a>
          </nav>
          <div className="flex items-center gap-2">
            {authEnabled ? (
              <AuthButton variant="header" />
            ) : (
              <button
                onClick={handleCta}
                className="text-xs font-medium bg-lime-500 hover:bg-lime-400 text-ink-900 rounded-lg px-3 py-1.5 transition"
              >
                Zaloguj się
              </button>
            )}
          </div>
        </div>
      </header>

      <main>
        <Hero onCta={handleCta} />
        <Pillars />
        <HowItWorks />
        <Pricing onCta={handleCta} />
        <FAQ />
        <CTASection onCta={handleCta} />
      </main>

      <Footer />
    </div>
  );
}
